
import { Textarea } from "@/components/ui/textarea";
import { Users, Brain } from "lucide-react";

export const formatOpenAIResponse = (reasoning: string, rawAnalysis?: any, getTeamStatsFromRecommendation?: () => any) => {
  try {
    const teamStats = getTeamStatsFromRecommendation ? getTeamStatsFromRecommendation() : { directors: 0, managers: 0, teamLeads: 0, teamMembers: 0 };
    const optimalTeamSize = teamStats.directors + teamStats.managers + teamStats.teamLeads + teamStats.teamMembers;
    
    let rationale = 'Detailed analysis based on project requirements and resource capabilities.';

    const jsonMatch = reasoning.match(/```json\s*([\s\S]*?)\s*```/);
    if (jsonMatch) {
      try {
        const jsonString = jsonMatch[1];
        const parsedData = JSON.parse(jsonString);
        rationale = parsedData.rationale || reasoning;
      } catch (parseError) {
        console.error('Error parsing JSON from reasoning:', parseError);
        if (rawAnalysis && typeof rawAnalysis === 'object') {
          rationale = rawAnalysis.rationale || reasoning;
        }
      }
    } else if (rawAnalysis && typeof rawAnalysis === 'object') {
      rationale = rawAnalysis.rationale || reasoning;
    }

    const formattedText = `Recommended team structure: The optimal team size is ${optimalTeamSize}, with ${teamStats.directors} directors, ${teamStats.managers} managers, ${teamStats.teamLeads} team leads, ${teamStats.teamMembers} team members.`;
    
    return (
      <div className="space-y-3 text-sm">
        <div className="bg-secondary/50 p-4 rounded-xl border border-blue-500/20">
          <h4 className="text-blue-300 font-bold mb-3 text-lg flex items-center gap-2">
            <Users className="h-5 w-5" />
            Team Structure Recommendation
          </h4>
          <div className="space-y-3">
            <div className="flex items-center justify-between bg-secondary/50 p-3 rounded-lg border border-blue-500/20">
              <span className="text-green-300 font-semibold">Optimal Team Size:</span>
              <span className="text-white text-lg font-bold">{optimalTeamSize} members</span>
            </div>
            <div className="grid grid-cols-4 gap-3">
              <div className="text-center bg-purple-500/10 p-2 rounded-lg border border-purple-500/20">
                <div className="text-purple-200 font-medium text-sm">Directors</div>
                <div className="text-white text-lg font-bold">{teamStats.directors}</div>
              </div>
              <div className="text-center bg-blue-500/10 p-2 rounded-lg border border-blue-500/20">
                <div className="text-blue-200 font-medium text-sm">Managers</div>
                <div className="text-white text-lg font-bold">{teamStats.managers}</div>
              </div>
              <div className="text-center bg-green-500/10 p-2 rounded-lg border border-green-500/20">
                <div className="text-green-200 font-medium text-sm">Team Leads</div>
                <div className="text-white text-lg font-bold">{teamStats.teamLeads}</div>
              </div>
              <div className="text-center bg-orange-500/10 p-2 rounded-lg border border-orange-500/20">
                <div className="text-orange-200 font-medium text-sm">Team Members</div>
                <div className="text-white text-lg font-bold">{teamStats.teamMembers}</div>
              </div>
            </div>
          </div>
        </div>
        
        <div className="bg-secondary/50 p-4 rounded-xl border border-purple-500/20">
          <h4 className="text-purple-300 font-bold mb-3 text-lg flex items-center gap-2">
            <Brain className="h-5 w-5" />
            AI Rationale
          </h4>
          <div className="bg-secondary/50 p-3 rounded-lg border border-purple-500/20">
            <Textarea
              value={formattedText}
              readOnly
              className="min-h-[200px] bg-transparent border-none text-gray-200 resize-none focus:ring-0 focus:outline-none"
            />
          </div>
        </div>
      </div>
    );
  } catch (error) {
    console.error('Error formatting OpenAI response:', error);
    return (
      <div className="bg-red-500/10 p-4 rounded-lg border border-red-500/20">
        <p className="text-red-300 text-sm">Error formatting response. Raw content:</p>
        <Textarea
          value={reasoning}
          readOnly
          className="min-h-[120px] bg-transparent border-none text-gray-200 resize-none focus:ring-0 focus:outline-none mt-2"
        />
      </div>
    );
  }
};
